import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG, REST_BASE_URL } from '../app.config';
import { AppConfig} from '../models/config/app-config';

@Injectable()
export class Ap2ModeService {

  constructor(private http: HttpClient,
              @Inject(APP_CONFIG) private appConfig: AppConfig) {
  }

  isAp2Mode(): Observable<boolean> {
    const serviceUrl = REST_BASE_URL + '/mek-visum-antrag/ap2-mode';


    const params = new HttpParams()
    .set('visumAntragsartEnum', this.appConfig.visumAntragsartEnum)
    // Nur für Mock-Backend Tests
    // params = params.append('mockValue', 'setFalse');

    // return ArrayObservable.of(false);

    return this.http.get<boolean>(serviceUrl, { params });
  }
}
